module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-right-white-90b7a8b74ea1ee6f0c4390a1f7e8a844.png";